import { TeamFieldsFragment } from '@/@generated/codegen/API';
import createTanstackTableDataStore from '@/ui/TanstackTable/createTanstackTableDataStore';

const useAdminTeamTableStore = createTanstackTableDataStore<TeamFieldsFragment>({
  storeName: 'admin-team-table-store',
  defaultColumnSizing: {},
  defaultColumnVisibility: {},
});

export default useAdminTeamTableStore;
